import React, { useCallback } from "react";
import { TerminalSquare, X } from "lucide-react";
import ScanOutputField from "./ScanOutputField";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function ViewScanOutputPopup({ output, closePopup }) {

    const handleClose = useCallback(() => closePopup(), [closePopup]);
    usePopupLifecycle(handleClose);

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="oct-scan-output-title">
            <div className="oct-shared-popup__backdrop" onClick={handleClose} />

            <div className="oct-shared-popup__dialog oct-shared-popup__dialog--xl" onClick={(event) => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <TerminalSquare size={18} />
                        </div>
                        <div>
                            <h4 id="oct-scan-output-title" className="oct-shared-popup__title">Nmap Scan Output</h4>
                            <p className="oct-shared-popup__subtitle">Inspect the raw scan output generated for this task.</p>
                        </div>
                    </div>

                    <button type="button" className="oct-shared-popup__close" onClick={handleClose} aria-label="Close Nmap scan output popup">
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-shared-popup__body--code">
                    <ScanOutputField value={output} />
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--secondary" onClick={handleClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    )

}

export default ViewScanOutputPopup;
